module.exports = {
	TestTarget : { getReactClass: function (){ return require('../components/TestTarget/TestTarget.jsx'); } }
};